import { IoC } from "../ServicesContainer";

export interface INavigationService {
  getHomeLink: string;

  goTo: (route: string, replace?: boolean) => void;
  goBack: () => void;
  goToLogin: () => void;

  getPreviousRoute: () => string;
  goToWorkerList: () => void;
}

const NavigationServiceName = "NavigationService";
const getNavigationService = () => IoC.get<INavigationService>(NavigationServiceName);

export { NavigationServiceName, getNavigationService };
